// constants
import { clockImages } from 'constants/images';

// libraries
import styled from 'styled-components';

export const StyledClock = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .clock-base {
    width: 100%;
    height: 100%;
    background: url(${clockImages.clock}) center center / contain no-repeat;
    border-radius: 50%;
    box-shadow: 0 0 5px #eee;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #646e82;
      border-radius: 50%;
      z-index: 2;
    }

    > div {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .clock-hour {
    width: 120px;
    height: 120px;

    &-hr {
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      position: absolute;
      border-radius: 50%;
      animation: hours 60s steps(12, end) 0s infinite;

      &:before {
        content: '';
        position: absolute;
        top: 38px;
        width: 2px;
        height: 32px;
        background: #646e82;
        z-index: 3;
        border-radius: 50px;
      }
    }
  }

  .clock-minute {
    width: 120px;
    height: 120px;

    &-mt {
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      position: absolute;
      border-radius: 50%;
      animation: hours 60s steps(6, end) 0s infinite;

      &:before {
        content: '';
        position: absolute;
        top: 29px;
        width: 2px;
        height: 41px;
        background: #646e82;
        z-index: 3;
        border-radius: 50px;
      }
    }
  }

  .clock-second {
    width: 120px;
    height: 120px;

    &-sc {
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      position: absolute;
      border-radius: 50%;
      animation: hours 60s steps(60, end) 0s infinite;

      &:before {
        content: '';
        position: absolute;
        top: 22px;
        width: 2px;
        height: 56px;
        background: url(${clockImages.hour}) center center / cover no-repeat;
        z-index: 11;
      }

      &:after {
        content: '';
        position: absolute;
        top: 60px;
        width: 3px;
        height: 3px;
        background: red;
        z-index: 11;
        border-radius: 50%;
      }
    }
  }
`;
